import React, { useState, useContext, useEffect } from "react";
import { AppSettings } from "../../config/app-settings.js";
import useAuthStore from "../../stores/auth-store.js";

function MusterStationUpdates() {
  const context = useContext(AppSettings);
  const user = useAuthStore((state) => state.user);

  // Setup app layout
  useEffect(() => {
    context.handleSetAppContentClass('');
    context.handleSetAppSidebarNone(true);
    context.handleSetAppSidebarTwo(false);
    context.handleSetAppSidebarWide(false);
    context.handleSetAppTopMenu(true);

    return () => {
      context.handleSetAppSidebarNone(false);
      context.handleSetAppSidebarTwo(false);
      context.handleSetAppSidebarWide(false);
      context.handleSetAppTopMenu(false);
    };
  }, [context]);

  // Form state
  const [formData, setFormData] = useState({
    zoneId: "8",
    musterStationName: "MNP Place",
    musterStationAddress: "4105 Gordon Drive - Kelowna",
    capacity: 150,
    occupancyRegular: "",
    occupancyVulnerable: "",
    occupancyLivestock: "",
    occupancyPets: "",
    notes: "",
  });

  // Calculate total occupied spaces and percentage
  const calculateTotals = () => {
    const regular = parseInt(formData.occupancyRegular) || 0;
    const vulnerable = parseInt(formData.occupancyVulnerable) || 0;
    const livestock = parseInt(formData.occupancyLivestock) || 0;
    const pets = parseInt(formData.occupancyPets) || 0;
    return {
      total: regular + vulnerable + livestock + pets,
      percentage: formData.capacity > 0 ? (((regular + vulnerable + livestock + pets) / formData.capacity) * 100).toFixed(2) : 0,
    };
  };

  const totals = calculateTotals();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Muster Station Update Submitted:", formData);
    alert("Muster Station Updates submitted (cosmetic only)");
  };

  const handleReset = () => {
    setFormData({
      zoneId: "8",
      musterStationName: "MNP Place",
      musterStationAddress: "4105 Gordon Drive - Kelowna",
      capacity: 150,
      occupancyRegular: "",
      occupancyVulnerable: "",
      occupancyLivestock: "",
      occupancyPets: "",
      notes: "",
    });
  };

  return (
    <div className="container-fluid mt-3 mb-3">
      <div className="row">
        <div className="col-12">
          <div className="card border-0 shadow-lg">
            <div className="card-header bg-dark text-white">
              <h4 className="mb-0">
                <i className="fa fa-map-location-dot me-2"></i>
                Muster Station Updates
              </h4>
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                {/* Muster Station Info Section - Horizontal */}
                <div className="mb-3">
                  <h6 className="text-uppercase text-muted mb-3">
                    <i className="fa fa-info-circle me-2"></i>
                    Muster Station Information
                  </h6>

                  <div className="row">
                    <div className="col-md-1 mb-3">
                      <label className="form-label fw-bold">Zone ID</label>
                      <p className="form-control-plaintext border p-2 rounded bg-light text-center">
                        {formData.zoneId}
                      </p>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold">Muster Station Name</label>
                      <p className="form-control-plaintext border p-2 rounded bg-light">
                        {formData.musterStationName}
                      </p>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold">Address</label>
                      <p className="form-control-plaintext border p-2 rounded bg-light">
                        {formData.musterStationAddress}
                      </p>
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label fw-bold">Capacity</label>
                      <p className="form-control-plaintext border p-2 rounded bg-light">
                        {formData.capacity}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Occupancy Section - All on one row */}
                <div className="mb-3">
                  <h6 className="text-uppercase text-muted mb-3">
                    <i className="fa fa-users me-2"></i>
                    Occupancy Status
                  </h6>

                  <div className="row">
                    <div className="col-md-2 mb-3">
                      <label htmlFor="occupancyRegular" className="form-label small">
                        Regular Vehicle
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        id="occupancyRegular"
                        name="occupancyRegular"
                        value={formData.occupancyRegular}
                        onChange={handleInputChange}
                        min="0"
                        placeholder="0"
                      />
                    </div>

                    <div className="col-md-2 mb-3">
                      <label htmlFor="occupancyVulnerable" className="form-label small">
                        Vulnerable Person
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        id="occupancyVulnerable"
                        name="occupancyVulnerable"
                        value={formData.occupancyVulnerable}
                        onChange={handleInputChange}
                        min="0"
                        placeholder="0"
                      />
                    </div>

                    <div className="col-md-2 mb-3">
                      <label htmlFor="occupancyLivestock" className="form-label small">
                        Livestock
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        id="occupancyLivestock"
                        name="occupancyLivestock"
                        value={formData.occupancyLivestock}
                        onChange={handleInputChange}
                        min="0"
                        placeholder="0"
                      />
                    </div>

                    <div className="col-md-2 mb-3">
                      <label htmlFor="occupancyPets" className="form-label small">
                        Pets
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        id="occupancyPets"
                        name="occupancyPets"
                        value={formData.occupancyPets}
                        onChange={handleInputChange}
                        min="0"
                        placeholder="0"
                      />
                    </div>

                    <div className="col-md-2 mb-3">
                      <label className="form-label small fw-bold">Total Spaces</label>
                      <p className="form-control-plaintext border p-2 rounded bg-light small text-center">
                        {totals.total}
                      </p>
                    </div>

                    <div className="col-md-2 mb-3">
                      <label className="form-label small fw-bold">% Occupied</label>
                      <p className="form-control-plaintext border p-2 rounded bg-light small text-center">
                        {totals.percentage}%
                      </p>
                    </div>
                  </div>
                </div>

                {/* Notes Section */}
                <div className="row">
                  <div className="col-12 mb-3">
                    <label htmlFor="notes" className="form-label">
                      <i className="fa fa-note-sticky me-2"></i>
                      Notes
                    </label>
                    <textarea
                      className="form-control form-control-sm"
                      id="notes"
                      name="notes"
                      rows="2"
                      value={formData.notes}
                      onChange={handleInputChange}
                      placeholder="Enter any additional notes..."
                    ></textarea>
                  </div>
                </div>

                {/* Form Actions */}
                <div className="d-flex gap-2 justify-content-end mt-3">
                  <button
                    type="reset"
                    className="btn btn-secondary btn-sm"
                    onClick={handleReset}
                  >
                    <i className="fa fa-redo me-2"></i>
                    Reset
                  </button>
                  <button type="submit" className="btn btn-primary btn-sm">
                    <i className="fa fa-save me-2"></i>
                    Submit Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MusterStationUpdates;
